import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "http://localhost:3004/api/auth/login",
        form
      );

      // Save JWT token and user info
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      toast.success("Login successful!", {
        position: "top-center",
        autoClose: 2000
      });

      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 2200);

    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid email or password", {
        position: "top-center",
        autoClose: 3000
      });
    }
  };

  return (
    <div
      className="container-fluid min-vh-100 d-flex justify-content-center align-items-center"
      style={{ background: "linear-gradient(135deg, #000000, #1a1a1a)" }}
    >
      <div className="col-md-4 col-sm-8">
        <div
          className="card shadow-lg border-warning"
          style={{ backgroundColor: "#0b0b0b" }}
        >
          <div className="card-body p-4">
            <h3 className="text-center text-warning mb-1">
              Investor Login
            </h3>
            <p className="text-center text-white mb-4">
              Secure Mutual Fund Access
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label text-warning">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control bg-dark text-light border-secondary"
                  placeholder="Enter email"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3 position-relative">
                <label className="form-label text-warning">
                  Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  className="form-control bg-dark text-light border-secondary"
                  placeholder="Enter password"
                  onChange={handleChange}
                  required
                />
                <span
                  style={{
                    position: "absolute",
                    top: "38px",
                    right: "10px",
                    cursor: "pointer",
                    color: "#ffc107"
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button className="btn btn-warning w-100 fw-bold">
                Login
              </button>
            </form>

            <div className="text-center mt-3">
              <span className="text-secondary">
                New investor?{" "}
                <Link to="/nse-registration" className="text-warning fw-semibold">
                  Register
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
}

export default Login;
